import { useSearchParams } from "react-router-dom";
import { Image } from "@/components/Image";
import verifiedAnimate from "@/images/verification.png";
import { Heading, Text } from "@/components/Typography";

export const LeadEmailSentPage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <div className="w-full min-h-[27.5rem] flex justify-center items-center">
      <div className="w-4/5 flex flex-col items-center gap-4">
        <div className="w-4/5 max-w-[17.5rem]">
          <Image
            src={verifiedAnimate}
            alt="Email Sent Illustration"
            className="w-full object-cover"
            ratio={1 / 1}
          />
        </div>
        <Heading size="6" as="h1" className="text-center font-bold">
          Email has been sent for verification
        </Heading>
        <Text size="4" as="p" className="text-center text-theme-text-secondary">
          {email
            ? `We have sent a verification link to ${email}. Please check your inbox and click "Meet Your Advisors" to continue.`
            : "We have sent a verification link to your email. Please check your inbox and click 'Meet Your Advisors' to continue."}
        </Text>
        <Text size="3" as="p" className="text-center text-theme-text-muted mt-4">
          Don't see the email? Check your spam folder.
        </Text>
      </div>
    </div>
  );
};
